import LockedUserMessage from "react/components/LockedUserMessage/LockedUserMessage";
import { UnlockButton } from "react/components/LockedUserMessage/UnlockButton";
import { CustomProvider, renderComponent } from "react/utils/renderUtils";
import { isValidLogin, getResourceTo } from "react/utils/utils";
import { DefaultRequest } from 'scripts/api';
import { actionCreators } from 'react/api/actions/modals';

/* Collection */
class UsersCollection extends App.Collections.BaseCollection {
    url = 'Users';
    model = App.Models.User;
}

App.Collections.Userss = UsersCollection;

/* Router */
class UsersRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Users';
        const model = App.Models.User;
        const collectionClass = App.Collections.Userss;

        super(entityName, model, collectionClass);

        this.state = {
          isChecked: false
        };
    }

    beforeSave = (saveModel) => {
      const userForm = App.Forms.Users.form;

      const confirmAction = () => {
        saveModel();
      };

      const cancelAction = () => {
        userForm.triggerLoadingBtns();
      };

      const props = {
        customConfirmButtonResource: 'emptyUserPasswordAlert.confirmButton',
        customCancelButtonResource: 'default.button.close'
      };

      const isCreateStage = userForm.crudStage === 'new';

      if (isCreateStage) {
        const passwordValue = userForm.fields?.password?.getValue() ?? "";

        if (!passwordValue) {
          new Greenmile.Components.AlertModal(
            'emptyUserPasswordAlert.description',
            'emptyUserPasswordAlert.title',
            confirmAction,
            cancelAction,
            props
          ).show();

          return;
        }
      }

      if(['edit', 'new'].includes(userForm.crudStage)) {
        const loginField = userForm.fields?.login;
        const loginValue = loginField?.getValue() ?? "";
        const loginElement = loginField?.rootEl;
        if (!isValidLogin(loginValue)) {

          const monetMessage = new Monet.Form.Messages.InlineMessage();
          const resourceMessage = Monet.I18n.getResourcesByKey("user.login.invalid");

          monetMessage.setScope(`#${this.entityName}`);
          monetMessage.setInfoType("error");
          monetMessage.setMessage(resourceMessage);
          monetMessage.triggerMessage();
          userForm.triggerLoadingBtns();

          loginElement.classList.add('error');
          loginElement.classList.add('control-group');

          return;
        } else {
          loginElement.classList.remove('error');
          loginElement.classList.remove('control-group');
        }
      }

      confirmAction();
    };

    beforeList = () => {
        const grid = App.Forms.Users.table;
        const unblockBtnContainerEl = document.querySelector('.user-unblock-button-container');
        const gridActions = document.querySelector('#Users .MonetUIGridActions');

        if(!unblockBtnContainerEl) {
            const unblockBtnContainer = document.createElement('div');
            unblockBtnContainer.classList.add('user-unblock-button-container');

            gridActions.appendChild(unblockBtnContainer);

            renderComponent(
                <CustomProvider>
                  <UnlockButton grid={grid} />
                </CustomProvider>,
                unblockBtnContainer
            );
        }

        if (!!this.collectionCriteria) {
            const criteria = JSON.parse(this.collectionCriteria);

            if (!criteria.filters.indexOf('lockDate') > -1) {
                criteria.filters.push('lockDate');
            }

            if(!criteria.filters.indexOf('expireDate') > -1) {
                criteria.filters.push('expireDate');
            }

            const customFilter = App.Forms[this.entityName].filterBuilder;
            customFilter.setProjection(JSON.stringify(criteria));
        }
    }

    beforeUpdate = (userForm) => {
        if (userForm.id === Monet.Session.User.id) {
            GreenmileReduxStore.dispatch({ type: 'GREENMILE_UPDATE_USER', payload: userForm });
            Monet.Session.User.email = userForm.email || '';
        }
    }

    beforeDestroy = (that, id) => {
        if (Monet.Session.User.id === id) {
            const monetMessage = new Monet.Form.Messages.AlertMessage();
            monetMessage.setMessage({
                errorMessage: {
                    message: Monet.I18n.getResourcesByKey("User.Delete.yourself")
                }
            });

            monetMessage.setScope("#form_Users");
            monetMessage.triggerMessage();
            window.location = "#/" + this.entityName;

            return false;
        }
        return true;
    }

    beforeCreate = (model_to_create) => {
        model_to_create.url = () => 'Users/Save';
    }

    unsetShareVisibilityToUserTarget = (model) => {
      model.unset('shareVisibilityToUserTarget');
    }

    shareDriversVisibilityWithUserTargetId = (userId, targetUserId, data) => {
      const request = new DefaultRequest({
        url: `UserDriver/${userId}/ShareDrivers/${targetUserId}`,
        method: 'post',
        data,
        success: function () {
          window.location = "#/" + this.entityName;
        }.bind(this),
        error: function (e) {
          this.createAndUpdateErrorHandler(e);
        }.bind(this)
      });
      request.send();
    }

    removeSharedVisibilityFromUserTargetId = (userId, targetUserId, data, callback) => {
      const request = new DefaultRequest({
        url: `UserDriver/${userId}/RemoveShareDrivers/${targetUserId}`,
        method: 'post',
        data,
        success: function () {
          callback();
        },
        error: function (e) {
          this.createAndUpdateErrorHandler(e);
        }.bind(this)
      });
      request.send();
    }

    getUserDriversFromUserIdAndRemoveSharedVisibility = (userId, targetUserId) => {
      const callback = (response) => {
        const afterRemoveSharedVisibility = () => {
          window.location = "#/" + this.entityName;
        }
        this.removeSharedVisibilityFromUserTargetId(userId, targetUserId, response.map(userDriver => userDriver.id), afterRemoveSharedVisibility);
      }
      this.getUserDriversFromUserIdAndExecuteCallback(userId, callback);
    }

    getUserDriversFromUserIdAndShareWithTargetUser = (userId, targetUserId) => {
      const callback = (response) => {
        this.shareDriversVisibilityWithUserTargetId(userId, targetUserId, response.map(userDriver => userDriver.id));
      }
      this.getUserDriversFromUserIdAndExecuteCallback(userId, callback);
    }

    getUserDriversFromUserIdAndExecuteCallback = (userId, callback) => {
      const getUserDriversFromUserId = new DefaultRequest({
        url: `UserDriver/restrictions?criteria={"filters": ["id", "driver.id", "user.id"]}`,
        method: 'post',
        data: {
          criteriaChain: [{ and: [{ attr: "user.id", eq: userId }] }]
        },
        success: function (response) {
          callback(response);
        }
      });
      getUserDriversFromUserId.send();
    }

    afterCreate = (model) => {
      const shareVisibilityToUserTarget = App.Forms.Users.form.fields?.shareVisibilityToUserTarget?.getValue();
      if (shareVisibilityToUserTarget?.id) {
        this.getUserDriversFromUserIdAndShareWithTargetUser(model.id, shareVisibilityToUserTarget.id);
        return;
      }

      const hiddenShareVisibilityToUserTargetId = document.querySelector('input[name="hiddenShareVisibilityToUserTargetId"]');
      if (!shareVisibilityToUserTarget?.id && hiddenShareVisibilityToUserTargetId?.value) {
        this.getUserDriversFromUserIdAndRemoveSharedVisibility(
          model.id,
          parseInt(hiddenShareVisibilityToUserTargetId.value, 10)
        );
        return;
      }

      window.location = "#/" + this.entityName;
    }

    beforePopulateLocalCollection = () => {
      const layout = App.Forms.Users.layout.edit;
      const projectionBuilder = new Monet.Builder.Projection();

      projectionBuilder.setLayout(layout);
      projectionBuilder.parseLayout();

      const { filters } = JSON.parse(projectionBuilder.projection.toString());
      const criteria = {
          filters: [
              ...filters.filter(filter => filter !== 'shareVisibilityToUserTarget.id' && filter !== 'shareVisibilityToUserTarget.name'),
              'userAllowedDrivers.user.id',
              'userAllowedDrivers.user.name',
              'userAllowedDrivers.userTarget.id',
              'userAllowedDrivers.userTarget.name',
              'lockDate',
              'expireDate',
              'groups.key'
          ]
      }

      this.projection = JSON.stringify(criteria);
    }

    beforeCreateForm = (entity, formData) => {
      const canChangePassword = !!Monet.Session.Security.permissions.find(
          permission => permission.key === "USER_CHANGE_PASSWORD"
      );
      const isAdmin = Monet.Session.User.groups.some(group => group.key === 'ADMIN');
      const shouldNotShowShareDriverVisibilityFeature = (field) => !isAdmin && (field.name === 'shareVisibilityToUserTarget' || field.name === 'allowShareRestrict');
      const shouldNotShowChangePassModal = (field) => !canChangePassword && field.name === 'show_change_pass_modal';

      formData.sections = formData.sections.reduce((accumulatedSections, section) => {
        section.sectionFields = section.sectionFields.reduce((accumulatedSectionFields, sectionField) => {
          if (
            shouldNotShowShareDriverVisibilityFeature(sectionField.field) ||
            shouldNotShowChangePassModal(sectionField.field)
          ) {
            return accumulatedSectionFields;
          }
          accumulatedSectionFields.push(sectionField);
          return accumulatedSectionFields;
        }, []);

        accumulatedSections.push(section);
        return accumulatedSections;
      }, []);
    }

    beforePopulateForm = (model) => {
      const userId = model.get('id');
      const sharedDrivers = model.get('userAllowedDrivers').reduce(
        (acc, allowedDriver) => {
          if (allowedDriver?.user?.id === userId) {
            acc.userAllowedDrivers.push(allowedDriver);
          } else if (allowedDriver?.userTarget?.id === userId) {
            const userSharingId = allowedDriver?.user?.id;
            if (!acc.shareVisibilityToUserTargetList.has(userSharingId)) {
              acc.shareVisibilityToUserTargetList.set(userSharingId, {
                userSharingId,
                userSharingName: allowedDriver?.user?.name,
                sharedDrivers: []
              });
            }
            acc.shareVisibilityToUserTargetList
              .get(userSharingId)
              ?.sharedDrivers.push({...allowedDriver.driver, userDriverId: allowedDriver.id});
          }
          return acc;
        },
        {
          userAllowedDrivers: [],
          shareVisibilityToUserTargetList: new Map()
        }
      );

      model.attributes.userAllowedDrivers = sharedDrivers.userAllowedDrivers;
      model.attributes.shareVisibilityToUserTarget = model.get('userAllowedDrivers').at(0)?.userTarget;
      model.attributes.shareVisibilityToUserTargetList = sharedDrivers.shareVisibilityToUserTargetList;

    }

    disableFieldsFromDriverPermissionsSection = () => {
      App.Forms.Users.form.fields.userAllowedDrivers.disable();
      App.Forms.Users.form.fields.allowShareRestrict?.disable();
      App.Forms.Users.form.fields.shareVisibilityToUserTarget?.disable();
    }

    enableFieldsFromDriverPermissionsSection = () => {
      const userForm = App.Forms.Users.form;
      const restrictDrivers = userForm.fields.restrictDrivers?.getValue();
      const visibilitySharing = userForm.getModel().attributes.visibilitySharing;
      const allowShareRestrict = userForm.fields.allowShareRestrict?.getValue();

      if (restrictDrivers) {
        userForm.fields.userAllowedDrivers?.enable();
        userForm.fields.allowShareRestrict?.enable();

        if (visibilitySharing !== 'RECEIVING_USERS') {
          userForm.fields.allowShareRestrict?.enable();

          if (allowShareRestrict) {
            userForm.fields.shareVisibilityToUserTarget?.enable();
          }
        }
      }
    }
    
    addListenerFieldsFromDriverPermissionsSection = () => {
      const driverList = document.getElementById('driver_list');
      const toggleAllowShareRestrict = (isChecked) => {
        if (!App.Forms.Users.form.fields.allowShareRestrict) return;
        const allowShareRestrict = App.Forms.Users.form.fields.allowShareRestrict;
    
        if (isChecked) {
          allowShareRestrict.enable();
          driverList.classList.remove('disabled');
        } else {
          allowShareRestrict.disable();
          allowShareRestrict.clear();
          allowShareRestrict.setValue(false);
          driverList.classList.add('disabled');
          toggleShareVisibilityToUserTarget(false);
        }    
      };
    
      const toggleShareVisibilityToUserTarget = (isChecked) => {
        if (!App.Forms.Users.form.fields.shareVisibilityToUserTarget) return;

        const shareVisibilityToUserTarget = App.Forms.Users.form.fields.shareVisibilityToUserTarget;

        if (isChecked) {
          shareVisibilityToUserTarget.enable();
        } else {
          shareVisibilityToUserTarget.clear();
          shareVisibilityToUserTarget.disable();
        }
      }
    
      const toggleUserAllowedDrivers = (isChecked) => {
        const userAllowedDrivers = App.Forms.Users.form.fields.userAllowedDrivers;
        const mainSupervisorButton = document.querySelector(
          '.btn-secondary.driver-shared-button'
        );

        if(mainSupervisorButton) {
          mainSupervisorButton.disabled = !isChecked;
        }
    
        if (isChecked) {
          userAllowedDrivers.enable();
        } else {
          userAllowedDrivers.disable();
        }
      }
    
      App.Forms.Users.form.fields.allowShareRestrict?.input.addEventListener('change', (e) => {
        toggleShareVisibilityToUserTarget(e.target.checked);
      });
    
      App.Forms.Users.form.fields.restrictDrivers?.input.addEventListener('change', (e) => {
        const visibilitySharing = App.Forms.Users.form.getModel().attributes.visibilitySharing;
        const isChecked = e.target.checked;
        toggleUserAllowedDrivers(isChecked);
        if (visibilitySharing !== 'RECEIVING_USERS') {
          toggleAllowShareRestrict(isChecked);
        }
      });
    };
    
    renderHelperTooltipForAllowShareRestrict = () => {
      if (!App.Forms.Users.form.fields.allowShareRestrict) return;
      const allowShareRestrict = App.Forms.Users.form.fields.allowShareRestrict;
      const tooltipElement = document.createElement('span');
      tooltipElement.className = 'MonetUIHelpLink';
      tooltipElement.dataset.title = Monet.I18n.getResourcesByKey("user.allowShareRestrict.tooltip");
      const allowShareRestrictLabel = document.querySelector(`#${allowShareRestrict.getId()} label`);
      allowShareRestrictLabel.classList.add('withHelper');
      allowShareRestrictLabel.appendChild(tooltipElement);
    }

    afterCreateForm = (entity, _, crudStage) => {
        if(crudStage === 'new') {
            const passwordField = App.Forms[entity].form.fields.password;
            const organizationField = App.Forms[entity].form.fields.organization;
            const groupsField = App.Forms[entity].form.fields.groups;
            const groupFieldList = groupsField.divLookupListWrapper;

            const usersForm = document.querySelector('.MonetUIForm.Users');

            passwordField.disable();

            organizationField.input.addEventListener('blur',() => {
                this.activatePasswordValidator(entity);
            });

            organizationField.addListenerToAfterSelectRow(() => {
                this.activatePasswordValidator(entity);
            });

            groupsField.addListenerToAfterSelectRow(() => {
                this.activatePasswordValidator(entity);
            });

            groupFieldList.addEventListener('click', () => {
                this.activatePasswordValidator(entity);
            })

            usersForm.addEventListener('scroll', () => {
                this.verifyInputValues(entity)
            });
        } else if (crudStage === 'edit') {
           this.verifyPermissionToSelfEditPassword();
        }

        if(['edit', 'new'].includes(crudStage)) {
          const loginFieldId = App.Forms[entity].form.fields.login.getId();
          const tooltipElement = document.createElement('span');
          tooltipElement.className = 'MonetUIHelpLink';
          tooltipElement.dataset.title = Monet.I18n.getResourcesByKey("user.login.invalid");
          const loginLabel = document.querySelector(`#${loginFieldId} label`);

          loginLabel.classList.add('withHelper');
          loginLabel.appendChild(tooltipElement);
          this.renderHelperTooltipForAllowShareRestrict();
          this.addListenerFieldsFromDriverPermissionsSection();
          this.disableFieldsFromDriverPermissionsSection(crudStage);
        }
    }

    setInputHiddenForShareVisibilityToUserTarget = () => {
      const shareVisibilityToUserTarget = App.Forms.Users.form.fields.shareVisibilityToUserTarget.getValue();

      if (shareVisibilityToUserTarget) {

        const inputHidden = document.createElement('input');

        inputHidden.type = 'hidden';
        inputHidden.name = 'hiddenShareVisibilityToUserTargetId';
        inputHidden.value = shareVisibilityToUserTarget.id;
        document.querySelector('[key="pls_edit_permission_driver_users"]').appendChild(inputHidden);
      }

    }

    afterPopulateForm = () => {
      const userForm = App.Forms.Users.form;
      const isEditStage = userForm.crudStage === 'edit';
      
      if (isEditStage) {
        userForm.fields?.externalUser?.disable();
    
        const userModel = userForm.getModel();
        const visibilitySharing = userModel.attributes.visibilitySharing;
    
        if (visibilitySharing === 'RECEIVING_USERS') {
          userForm.fields?.shareVisibilityToUserTarget?.hide();
        } else {
          this.setInputHiddenForShareVisibilityToUserTarget();
        }

        this.enableFieldsFromDriverPermissionsSection();
        this.renderSharedDriversList();
    
        if (this.hasAdminGroup(Monet.Session.User.groups)) {
          this.renderManagerDriverSupervisor();
        }
      }
    
      const model = userForm.getModel();
      const { lockDate, expireDate } = model.toJSON();

      if(lockDate || expireDate) {
        const blockedUserContainer = document.createElement('div');
        blockedUserContainer.classList.add('blocked-user-message');

        const { parentElement } = document.querySelector('.MonetUIFormSectionButton.buttonsUp');
        parentElement.appendChild(blockedUserContainer);

        renderComponent(
            <CustomProvider>
              <LockedUserMessage user={model.toJSON()} />
            </CustomProvider>,
            blockedUserContainer
        );
      }
    };
    
    hasAdminGroup = (groups) => {
      return Array.isArray(groups) && groups.some(group => group.key === "ADMIN" && group.admin === true);
    };
      

    configureFilterForUserTarget = (lookupReference) => {
      const configureCriteriaBeforeFilter = (criteria) => {
        const sharingVisibilityCriteriaCondition = {
          "or": [
            {
              "attr": "visibilitySharing",
              "neq": "SHARING_USERS"
            },
            {
              "attr": "visibilitySharing",
              "isNull": true
            }
          ]
        }

        const groupCriteria = {
          "attr":"groups.key",
          "neq" : "DRIVER"
        };

        const activeCriteria = {
          "attr": "enabled",
          "eq": true
        }

        criteria.criteriaChain[0].and.push(sharingVisibilityCriteriaCondition);
        criteria.criteriaChain[0].and.push(groupCriteria);
        criteria.criteriaChain[0].and.push(activeCriteria);

        return criteria;
      };

      lookupReference.filter.changeCriteriaBeforeFilter = configureCriteriaBeforeFilter;
    }

    verifyPermissionToSelfEditPassword = () => {
        const loggedUser = Monet.Session.User;
        const hasPermissionToEdit = !loggedUser.externalUser ||
            this.editModelId !== String(loggedUser.id);

        if (!hasPermissionToEdit) {
            const changePasswordLink =  App.Forms.Users.form.fields.show_change_pass_modal;

            changePasswordLink.disable();
            changePasswordLink.hide();
        }
    }

    verifyInputValues = (entity) => {
        const passwordField = App.Forms[entity].form.fields.password.input;
        const organizationValue = App.Forms[entity].form.fields.organization.getValue();
        const groupsValue = App.Forms[entity].form.fields.groups.getValue();

        const isValuesNotValid = !organizationValue || !groupsValue.length;
        const isPasswordInputDisabled = passwordField.hasAttribute('disabled');

        if(isValuesNotValid && !isPasswordInputDisabled) {
            $('.passwordHints').remove();
            App.Forms[entity].form.fields.password.disable();
        }
    }

    activatePasswordValidator = (entity) => {
        const passwordField = App.Forms[entity].form.fields.password.input;
        const saveUserBtn = App.Forms.Users.form.buttons.btn_save[0].input;
        const organizationValue = App.Forms[entity].form.fields.organization.getValue();
        const groupsValue = App.Forms[entity].form.fields.groups.getValue();

        $('.passwordHints').remove();

        if(organizationValue && groupsValue.length) {
            const passwordValidator = new Greenmile.Components.PasswordValidator(
                "",
                passwordField,
                null,
                saveUserBtn
            ).render();

            App.Forms[entity].form.fields.password.enable();
            $(passwordValidator).insertAfter(passwordField.parentElement)
        } else {
            App.Forms[entity].form.fields.password.disable();
        }
    }

    showChangePasswordModal = (entity) => {
        const isExternalUser = App.Forms[entity].form.fields.externalUser.getValue();

        if(!isExternalUser) {
            const changePasswordModal = new Greenmile.Components.ChangePasswordModal(entity);
            changePasswordModal.changePassword.loginField.value = App.Forms[entity].form.fields.login.getValue();
            changePasswordModal.changePassword.loginField.disabled = true;
            changePasswordModal.changePassword.createPasswordValidator = true;
            changePasswordModal.changePassword.hideCurrentField = true;

            changePasswordModal.changePassword.onChangePassword = function () {
                changePasswordModal.hide();
            };

            changePasswordModal.changePassword.sendNewPassword = function () {
                var isValid = this.validateForm(),
                    request = null,
                    formData = {
                        login: null,
                        password: null,
                        passwordConfirmation: null
                    };

                this.toogleLoading(true);

                if (isValid) {
                    formData.login = this.loginField.value;
                    formData.password = this.newField.value;
                    formData.passwordConfirmation = this.newConfirmField.value;

                    request = new Monet.Ajax();
                    request.url = 'User/ForceChangePassword';
                    request.data = formData;
                    request.method = 'post';

                    request.success = (function () {
                        const monetMessage = new Monet.Form.Messages.InlineMessage();
                        const resourceMessage = Monet.I18n.getResourcesByKey("user.changePassword.success")

                        this.passwordReseted(this);

                        monetMessage.setScope(`#${entity}`);
                        monetMessage.setInfoType("success");
                        monetMessage.setMessage(resourceMessage);
                        monetMessage.triggerMessage();
                    }).bind(this);

                    request.error = (function (e) {
                        this.passwordResetError(e);
                    }).bind(this);

                    request.send();
                } else {
                    this.errorDiv.innerHTML = Monet.I18n.getResourcesByKey('user.changePassword.formValuesAreInvalid');

                    this.errorDiv.style.display = 'block';
                    this.toogleLoading(false);
                }
            };

            changePasswordModal.show();
        }

        if(isExternalUser) {
            new Greenmile.Components.AlertModal(
              'unableChangePasswordAlert.message',
              'unableChangePasswordAlert.title',
            ).show();
        }
    }

    onClickButton = (event) => {
      const userForm = App.Forms.Users.form;
      event.preventDefault();
  
      const userModel = userForm?.getModel();
      const driverModel = userForm.fields.userAllowedDrivers.getValue();
  
      if (userModel) {
        const userInfo = userModel.toJSON();

        window.GreenmileReduxStore.dispatch(
          actionCreators.openModal({
            modalKey: 'MainSupervisorModal',
            title: getResourceTo('ManageDriverSupervisor.Title'),
            data: {
              drivers: driverModel,
              userId: userInfo.id,
            }
          })
        );
      }
    };
  
    renderVisibilityRestrictionButton = (container) => {
      if (!container) return;
    
      const userForm = App.Forms.Users.form;
      const driverModel = userForm.fields.userAllowedDrivers.getValue();
      const restrictDrivers = userForm.fields.restrictDrivers.getValue();
    
      const isDisabled = !restrictDrivers && (!driverModel || driverModel.length === 0);
    
      const label = document.createElement('label');
      label.classList.add('withHelper');
    
      const button = document.createElement('button');
      button.classList.add('btn-secondary', 'driver-shared-button');
      button.textContent = Monet.I18n.getResourcesByKey('ManageDriverSupervisor.Title');
      button.disabled = isDisabled;
      button.addEventListener('click', (event) => this.onClickButton(event));
    
      const tooltipElement = document.createElement('span');
      tooltipElement.className = 'MonetUIHelpLink';
      tooltipElement.dataset.title =
        Monet.I18n.getResourcesByKey('ManageDriverSupervisor.Button.Help');
    
      label.appendChild(button);
      label.appendChild(tooltipElement);
    
      container.appendChild(label);
    };
  
    renderManagerDriverSupervisor = () => {
      const ManageDriverSupContainer = document.createElement('div');
      ManageDriverSupContainer.classList.add(
        'manage-driver-supervisor-container'
      );
  
      const formContainer = document.querySelector(
        '#Users div[key="pls_edit_permission_driver_users"] div.MonetUIFormSectionColumn[sectionColumn="1"]'
      );
      if (!formContainer) return;
  
      formContainer.appendChild(ManageDriverSupContainer);
  
      this.renderVisibilityRestrictionButton(ManageDriverSupContainer);
    };  

    removeTheSharedDriversListFromModelAndFormByUserId = (userId) => {
      const sharedDriversListContainer = document.querySelector(
        `.drivers-list[driverListId="${userId}"]`
      );
      sharedDriversListContainer?.parentElement?.removeChild(
        sharedDriversListContainer
      );

      const form = App.Forms.Users.form;
      const sharedDriversList =
        form.getModel().attributes?.shareVisibilityToUserTargetList;

      sharedDriversList.delete(userId);

      if (!sharedDriversList.size) {
        form.fields.visibilitySharing.setValue('');
        form.fields.shareVisibilityToUserTarget.show();
      }
    }

    renderDriversList = ({ userSharingId, userSharingName, sharedDrivers }) => {
      const driversListContainer = document.createElement('div');
      const container = document.createElement('div');
      const userSharedFromLabel = document.createElement('label');
      const removeAllElementsButton = document.createElement('div');
      const driverElements = document.createElement('div');

      removeAllElementsButton.classList.add('power-lookup-list-remove-all-elements');
      driversListContainer.classList.add('drivers-list');
      container.classList.add('container_lookuplist_added');
      driversListContainer.setAttribute('driverListId', userSharingId);

      userSharedFromLabel.textContent = `${Monet.I18n.getResourcesByKey('user.sharedFrom')} ${userSharingName}`;
      removeAllElementsButton.innerHTML = `<i class="fa fa-trash-o"></i> ${Monet.I18n.getResourcesByKey('lookupList.removeAllElements')}`;
      removeAllElementsButton.addEventListener('click', () => {
        this.showRemoveSharedDriversModal(userSharingId, sharedDrivers, userSharingName);
      });

      sharedDrivers.forEach(driver => {
        const driverElement = document.createElement('div');
        driverElement.classList.add('zebrado');
        driverElement.textContent = driver.name;
        driverElements.appendChild(driverElement);
      });

      container.appendChild(driverElements);
      container.appendChild(removeAllElementsButton);
      driversListContainer.appendChild(userSharedFromLabel);
      driversListContainer.appendChild(container);
      return driversListContainer;
    }

    renderSharedDriversList = () => {
      const sharedDrivers = App.Forms.Users.form.getModel().attributes.shareVisibilityToUserTargetList;
      const sectionField = document.querySelector('#Users div[key="pls_edit_permission_driver_users"] div.MonetUIFormSectionColumn[sectionColumn="2"]');
      const sharedDriversList = document.createElement('div');
      sharedDriversList.classList.add('shared-drivers-list');
      sharedDrivers.forEach(sharedDriver => {
        sharedDriversList.appendChild(this.renderDriversList(sharedDriver));
      });

      sectionField.appendChild(sharedDriversList);

    }

    showRemoveSharedDriversModal = (userSharingId, sharedDrivers, userTargetName) => {
      const onAfterShowModalForm = () => {
        const popupContainer = document.querySelector(
          '#Users .popupFormContainer'
        );
        const fragment = document.createDocumentFragment();
        const title = document.createElement('h2');
        const descriptionContainer = document.createElement('div');
        const description = document.createElement('p');
        const bottomContainer = document.createElement('div');
        const confirmButton = document.createElement('input');
        const cancelButton = document.createElement('input');

        descriptionContainer.classList.add('descriptionContainer');
        bottomContainer.classList.add('bottomContainer');
        bottomContainer.classList.add('confirmButtons');

        confirmButton.type = 'button';
        cancelButton.type = 'button';

        confirmButton.setAttribute('buttonOrder', '2');
        confirmButton.classList.add('MonetUIButton');
        cancelButton.setAttribute('buttonOrder', '1');
        cancelButton.classList.add('MonetUIButton');

        title.textContent = Monet.I18n.getResourcesByKey(
          'user.removeSharedDriversModal.title'
        );
        description.textContent = Monet.I18n.getResourcesByKey(
          'user.removeSharedDriversModal.description'
        ).replaceAll('{userName}', userTargetName);
        confirmButton.value = Monet.I18n.getResourcesByKey(
          'lookupList.removeAllElements'
        );
        cancelButton.value = Monet.I18n.getResourcesByKey(
          'default.button.cancel'
        );

        confirmButton.addEventListener('click', () => {
          this.removeSharedDriversModal.toggleLoadingInModalBtn();
          this.removeSharedVisibilityFromUserTargetId(
            userSharingId,
            App.Forms.Users.form.getModel().attributes.id,
            sharedDrivers.map((driver) => driver.userDriverId),
            () => {
              this.removeTheSharedDriversListFromModelAndFormByUserId(
                userSharingId
              );
              this.removeSharedDriversModal.closeModalWindow();
            }
          );
        });
        cancelButton.addEventListener('click', () => {
          this.removeSharedDriversModal.closeModalWindow();
        });

        descriptionContainer.appendChild(description);

        bottomContainer.appendChild(cancelButton);
        bottomContainer.appendChild(confirmButton);

        fragment.appendChild(title);
        fragment.appendChild(descriptionContainer);
        fragment.appendChild(bottomContainer);

        popupContainer.appendChild(fragment);
      };
      this.removeSharedDriversModal = new Monet.Form.Modal(
        '#Users',
        { width: 400, height: 200 },
        { onAfterShowModalForm }
      );
      this.removeSharedDriversModal.showModalForm();
    }
}

App.Routers.Users = UsersRouter;
